import Collapse from '@mui/material/Collapse';
import { Theme } from '@mui/material';
import styled from '@mui/system/styled';

export const Wrapper = styled('div')({
  backgroundRepeat: 'no-repeat',
  position: 'relative',
  marginBottom: '20px'
});

export const Title = styled('div')(({ theme }: { theme?: Theme }) => ({
  color: theme.palette.primary.dark,
  textDecoration: 'none',
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.primary.main
  }
}));

export const StyledCollapse = styled(Collapse)({
  paddingTop: '3px'
});
